/**
 * [PB-1739] On mobile devices click on konva canvas element does not trigger blur in input elements
 * This is workaround to trigger blur event when konva stage is touched
 */
export function blurDocumentActiveElement() {
	if (document.activeElement instanceof HTMLElement) {
		document.activeElement.blur()
	}
}